<div class="w-full bg-[#001c3a] text-white text-sm py-2 px-6 flex justify-between items-center">
    <a href="tel:800-728-5768" class="flex items-center"><mat-icon class="mr-2">phone</mat-icon> 800-728-5768</a>
    <a href="https://www.legalresources.com/contact-us/" target="_blank">Contact Us</a>
</div>
<header class="bg-white shadow-md py-4 px-6 w-full flex justify-center">
    <img src="/assets/legal-resources-logo.png" alt="Legal Resources Logo" class="h-16">
</header>